import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  userId: string | null;
  token: string | null;
  refreshToken: string | null;
  fullName: string | null;
  profileImage: string | null;
  googleLocationApiKey: string | null;
}

const initialState: UserState = {
  userId: null,
  token: null,
  refreshToken: null,
  fullName: null,
  profileImage: null,
  googleLocationApiKey: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserId: (state, action: PayloadAction<string>) => {
      state.userId = action.payload;
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    setRefreshToken: (state, action: PayloadAction<string>) => {
      state.refreshToken = action.payload;
    },
    setFullName: (state, action: PayloadAction<string>) => {
      state.fullName = action.payload;
    },
    setProfileImage: (state, action: PayloadAction<string>) => {
      state.profileImage = action.payload;
    },
    setGoogleLocationApiKey: (state, action: PayloadAction<string>) => {
      state.googleLocationApiKey = action.payload;
    },
    clearUser: (state) => {
      state.userId = null;
      state.token = null;
      state.refreshToken = null;
      state.fullName = null;
      state.profileImage = null;
      state.googleLocationApiKey = null;
    },
  },
});

export const { 
  setUserId, 
  setToken, 
  setRefreshToken, 
  setFullName, 
  setProfileImage, 
  setGoogleLocationApiKey,
  clearUser 
} = userSlice.actions;
export default userSlice.reducer; 